import script from "./ModalAddMiembroEquipo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalAddMiembroEquipo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalAddMiembroEquipo.vue?vue&type=style&index=0&id=a42a5dd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a42a5dd8"]])

export default __exports__